import { render, staticRenderFns } from "./ShoppingCartBtn.vue?vue&type=template&id=a5e45294&"
import script from "./ShoppingCartBtn.vue?vue&type=script&lang=ts&"
export * from "./ShoppingCartBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseButton: require('/home/vsts/work/1/a/NuxtApp/components/base/Button.vue').default,AppHeaderCartSummary: require('/home/vsts/work/1/a/NuxtApp/components/app/header/CartSummary.vue').default})
